import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const LABELS_SCHEMA = Object.freeze({
  LB_ADDRESS_HEADER_INV: '',
  LB_ADDRESS_HEADER_OTHERS: '',
  LB_BANK_DETAILS_ACCOUNT_NUMBER: '',
  LB_BANK_DETAILS_ROUTING_NUMBER: '',
  LB_BANK_DETAILS_TITLE: '',
  LB_BALANCE_DUE: '',
  LB_BREAKDOWN_SUBTOTAL: '',
  LB_CLIENT_SIGNATURE: '',
  LB_COMBINED_TAX_COLUMN_NAME: '',
  LB_COMPANY_SIGNATURE: '',
  LB_DEPOSIT_DUE: '',
  LB_DEPOSIT_NOTE_AMOUNT_ON_ESTIMATE: '',
  LB_DEPOSIT_NOTE_ON_INVOICE: '',
  LB_DEPOSIT_NOTE_PERCENTAGE_ON_ESTIMATE: '',
  LB_DISCOUNT: '',
  LB_DOCUMENT_DATE: '',
  LB_DOCUMENT_FILE_NAME_CRN: '', // not used
  LB_DOCUMENT_FILE_NAME_EST: '', // not used
  LB_DOCUMENT_FILE_NAME_INV: '', // not used
  LB_DOCUMENT_FILE_NAME_PO: '', // not used
  LB_DOCUMENT_HEADER_CRN: '',
  LB_DOCUMENT_HEADER_EST: '',
  LB_DOCUMENT_HEADER_INV: '',
  LB_DOCUMENT_HEADER_PO: '',
  LB_DOCUMENT_NUMBER_CRN: '',
  LB_DOCUMENT_NUMBER_EST: '',
  LB_DOCUMENT_NUMBER_INV: '',
  LB_DOCUMENT_NUMBER_PO: '',
  LB_DUE_DATE: '',
  LB_FOB: '',
  LB_FPT_FEE_AMOUNT: '',
  LB_INCLUDE_TEXT: '',
  LB_ITEM_AMOUNT: '',
  LB_ITEM_CODE: '',
  LB_ITEM_DESCRIPTION: '',
  LB_ITEM_DISCOUNT_RATE: '',
  LB_ITEM_QTY: '',
  LB_ITEM_RATE: '',
  LB_ITEM_TAX_RATE: '',
  LB_LABOR_SUBTOTAL: '',
  LB_LABOR_TOTAL: '',
  LB_NON_TAXABLE: '',
  LB_NOTES: '',
  LB_PAID: '', // deprecated on the server
  LB_PAID_STAMP: '',
  LB_PAID_TEXT: '',
  LB_PARTIALLY_TAXABLE: '',
  LB_PARTS_SUBTOTAL: '',
  LB_PARTS_TOTAL: '',
  LB_PAYMENT_DETAILS: '',
  LB_PAY_NOW_BUTTON: '',
  LB_REMITTANCE_AMOUNT_PAID: '',
  LB_REMITTANCE_BALANCE_DUE: '',
  LB_REMITTANCE_CARDHOLDERS_NAME: '',
  LB_REMITTANCE_CARD_NUMBER: '',
  LB_REMITTANCE_CARD_TYPE: '',
  LB_REMITTANCE_CVV: '',
  LB_REMITTANCE_EXPIRY_DATE: '',
  LB_REMITTANCE_RECEIVED_FROM: '',
  LB_REMITTANCE_SIGNATURE: '',
  LB_REMITTANCE_TEXT: '',
  LB_REMITTANCE_TITLE: '',
  LB_SHIPPING: '',
  LB_SHIP_DATE: '',
  LB_SHIP_TO: '',
  LB_SHIP_VIA: '',
  LB_SUBTOTAL: '',
  LB_TABLE_TAXABLE_AMOUNT: '',
  LB_TABLE_TAX_AMOUNT: '',
  LB_TAX_COMMENT: '',
  LB_TERMS: '',
  LB_TERMS_AND_CONDITIONS: '',
  LB_TERMS_FORMAT: '',
  LB_TOTAL: '',
  LB_TRACKING_NO: '',
});
const RECORD = generateSchema(LABELS_SCHEMA);
const KEYS: any = generateKeys(LABELS_SCHEMA);

export class Labels extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }
}
